import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {HttpClient} from '@angular/common/http';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {GridValueChangeEvent} from '@shared/models/common.models';

@Injectable({
  providedIn: 'root',
})
export class PlatformToolTransactionTrackerHandler implements IPlatformToolHandler {
  magicLinkModel: MagicLinkModel;
  ngUnsubscribe = new Subject<void>();
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  invalidateSubject: InvalidateSubject;
  constructor(private httpClient: HttpClient,
              private commandService: CommandService,
              private router: Router,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService
  ) {
  }
  executeCommand(command: PlatformCommand) {
    this.executeCommandApi(command);
  }

  private executeCommandApi(command: PlatformCommand) {
    console.log('[Executing PlatformCommand] -> ', command.name);
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(res => {
          console.log('Command Response', res);
          this.fuseSplashScreenService.hide();
          if (res.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(res.fieldValues['RedirectUrl']);
            return;
          }
          if (res.fieldValues['RedirectCommand']) {
            this.executeCommand(res.fieldValues['RedirectCommand']);
            return;
          }
          if (res.fieldValues['PlatformLinkModel']) {
            this.magicLinkModelValueChanged.emit({id: 'PlatformToolContainerComponent', value: res.fieldValues['PlatformLinkModel']});
          }
          if (res.fieldValues['SnackBarMessage']) {
            const duration = res.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(res.fieldValues['SnackBarMessage'], duration);
          }
          this.invalidate(command);
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
  }
  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private handleActions($event: GridValueChangeEvent) {
    switch ($event.action.id) {
      case 'Edit':
        break;
      default:
        if (this.magicLinkModel.additionalCommands[$event.action.id]) {
          const command = this.magicLinkModel.additionalCommands[$event.action.id];
          command.fieldValues['ItemId'] = $event.item.id;
          this.executeCommand(command);
        }
        break;
    }
  }

  valueChanged($event: GridValueChangeEvent) {
    console.log('[Event]', $event);
    if ($event.action) {
      this.handleActions($event);
      return;
    }
    if ($event.item && $event.fieldDefinition && $event.fieldSection) {
      switch ($event.fieldSection.headerKey) {
        case 'ConsolidationRules':
          this.handleConsolidationRulesEvents($event);
          return;
        case 'TransactionBucket':
          this.handleTransactionBucketEvents($event);
          return ;
      }
    }
  }

  private handleConsolidationRulesEvents($event: GridValueChangeEvent) {
    switch ($event.fieldDefinition.key) {
      case 'Title':
        const command = this.magicLinkModel.additionalCommands['EditConsolidationRuleToolLinkCommand'];
        command.fieldValues['ConsolidationRuleId'] = $event.item.id;
        this.executeCommandApi(command);
        return ;
    }
  }

  private invalidate(command: PlatformCommand) {
    switch (command.name) {
      case 'AddBucketCategoryCommand':
        this.invalidateSubject.invalidate('BucketsCategory');
        return ;
      default:
        this.invalidateSubject.invalidate();
    }
  }

  private handleTransactionBucketEvents($event: GridValueChangeEvent) {
    switch ($event.fieldDefinition.key) {
      case 'BucketName':
        const command = this.magicLinkModel.additionalCommands['OpenBucketCommand'];
        command.fieldValues['BucketId'] = $event.item.id;
        this.executeCommandApi(command);
        return ;
    }
  }
}
